import { render, staticRenderFns } from "./activityDyx.vue?vue&type=template&id=33c08e62&scoped=true"
import script from "./activityDyx.vue?vue&type=script&lang=js"
export * from "./activityDyx.vue?vue&type=script&lang=js"
import style0 from "./activityDyx.vue?vue&type=style&index=0&id=33c08e62&lang=less"
import style1 from "./activityDyx.vue?vue&type=style&index=1&id=33c08e62&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c08e62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33c08e62')) {
      api.createRecord('33c08e62', component.options)
    } else {
      api.reload('33c08e62', component.options)
    }
    module.hot.accept("./activityDyx.vue?vue&type=template&id=33c08e62&scoped=true", function () {
      api.rerender('33c08e62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/marketing/activity/addactivity/activityDyx.vue"
export default component.exports